// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__LWWZF","load8":"Spinner_load8__1kjQt","ButtonStyle":"Spinner_ButtonStyle__1pOxF"};